@if (initialized && subscription) {
  <app-upgrade-one
    [productPrice]="pcOnePrice"
    [productDiscount]="pcOneDiscount"
    (back)="onBackChangeCu()"
    [subscription]="subscription"
    (next)="onProductSelected($event)">
  </app-upgrade-one>
}
